module.exports = __webpack_public_path__ + "media/images/wedding/12-0eb47de074ca53f5aad429e33327e526.jpg";